import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
          <i className={`${icon} text-lg`} />
        </span>
        <div className="min-w-0">
          <h2 className="font-heading font-extrabold text-lg md:text-2xl text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5 truncate">{subtitle}</p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition cursor-pointer whitespace-nowrap shrink-0"
        >
          {moreLabel ?? "查看更多"}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}